<template>
  <Stack gap="2">
    <Buttons
      v-for="(item, index) in localList"
      :key="index"
      size="2"
    >
      <TextInput
        size="3"
        :value="localList[index]"
        @input="e => handleUpdate(index, e)"
      />
      <Button
        size="3"
        icon-only="fas fa-times"
        @click="remove(index)"
      />
    </Buttons>

    <Buttons>
      <Button
        size="3"
        icon-before="fas fa-plus"
        @click="add"
      >
        Add
      </Button>
    </Buttons>
  </Stack>
</template>

<script setup>
import { defineEmits, ref, watch } from 'vue';
import { Button, Buttons, Stack, TextInput } from '@stakeui';

const props = defineProps({
  value: {
    type: Array,
    default: () => [],
  },
});

const emit = defineEmits(['input']);

const localList = ref([...props.value]);

// Keep localList in sync with incoming prop changes
watch(
    () => props.value,
    newVal => {
      localList.value = [...newVal];
    },
    { deep: true },
);

// Emit updated list
function updateModel() {
  emit('input', [...localList.value]);
}

function handleUpdate(index, value) {
  localList.value[index] = value;
  updateModel();
}

function add() {
  localList.value.push('');
  updateModel();
}

function remove(index) {
  localList.value.splice(index, 1);
  updateModel();
}
</script>
